import React, { FC } from 'react';
import { TCHSeriesDetailDownloadBrochuresDataAssets } from '../../types/productSeriesDetailDownloadBrochures.types';
import { withTranslation, WithTranslation } from 'react-i18next';
import Icon from '../../../@shared/icon';
import RoutableNotEditableLink from '../../../@shared/routableNotEditableLink';
import Picture from '../../../@shared/picture';
import { googleClickCtaEvent } from '../../../../utils/analytics';
import { iconSize } from '../../../../constants/icon.constants';
import DictionaryTerm from '../../../@shared/dictionaryTerm';

const BrochureCard: FC<WithTranslation & TCHSeriesDetailDownloadBrochuresDataAssets> = (props) => {
  // eslint-disable-next-line @typescript-eslint/camelcase
  const { rendition_desktop_size500, rendition_mobile_size500, alt, size, full, icon, componentNumber, digitalBrochureUrl } = props;
  const { t } = props;

  return (
    <article className="brochure_card__article">
        <Picture
          productImageProps={{
            desktopRendition: rendition_desktop_size500,
            mobileRendition: rendition_mobile_size500,
            alt,
            pictureClassName: 'brochure_card__article__picture--fixed-aspect-ratio',
          }}
        />
      <div className="brochure_card__content-block">
        {alt ? <h2 className="brochure_card__title">{alt}</h2> : null}
        {size ? <div className="brochure_card__sub-heading"> {size} MB </div> : null}
      </div>
      <div className="brochure_card__link-wrapper">
        {digitalBrochureUrl ? (
          <RoutableNotEditableLink href={digitalBrochureUrl} target="_blank" className={'brochure_card__link brochure_card__link--view'}>
            <span className="brochure_card__link brochure_card__link--label">
              <DictionaryTerm keyword="cnhi-view" />
            </span>
            <Icon iconField={icon[2]} color="primary" extraClassName="brochure_card__link__icon" size={iconSize.dsk} />
          </RoutableNotEditableLink>
        ) : (
          <div className={'brochure_card__link brochure_card__link--share'}>
            <div className="a2a_kit a2a_kit_size_32 a2a_default_style brochure_card__link brochure_card__link--label">
              <a className="a2a_dd brochure_card__add-to-any" data-a2a-url={full} data-a2a-title={alt}>
                <span
                  role="button"
                  className="brochure_card__link-text"
                  onClick={() => googleClickCtaEvent('Brochure', t('cnhi-share'), alt, componentNumber)}
                >
                  {t('cnhi-share')}
                </span>
                <Icon iconField={icon[0]} color="primary" size={24} />
              </a>
            </div>
          </div>
        )}
        <RoutableNotEditableLink
          href={full}
          target="_blank"
          className={'brochure_card__link brochure_card__link--download'}
          onClick={() => googleClickCtaEvent('Brochure', t('cnhi-download'), alt, componentNumber)}
        >
          <span className="brochure_card__link brochure_card__link--label">{t('cnhi-download')}</span>
          <Icon iconField={icon[1]} color="primary" extraClassName="brochure_card__link__icon" size={25} />
        </RoutableNotEditableLink>
      </div>
    </article>
  );
};

export default withTranslation()(BrochureCard);
